import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import api from '../../service/api';
import { formatCurrency } from '../../service/format';
import InputDecimal from '../../components/InputDecimal';

const Create = () => {
    const { code } = useParams();

    let emptyViability = {
        shipping_price: null,
        description: '',
        commission: null,
        depreciation: null,
        distance: null,
        fuelPrice: null,
        routes: [],
        truck: null,
        isempty: false
    };

    var paramEmpty = {
        driverCommission: 0,
        truckWear: 0
    }

    const [routes, setRoutes] = useState([]);
    const [params, setParams] = useState(paramEmpty);
    const [tollValue, setTollValue] = useState(0);
    const [totalValue, setTotalValue] = useState(0);
    const [fuelValue, setFuelValue] = useState(0);
    const [profitValue, setProfitValue] = useState(0);
    const [routesSelected, setRoutesSelected] = useState([]);
    const [trucks, setTrucks] = useState([]);
    const [viability, setViability] = useState(emptyViability);
    const [selectedRoutes] = useState([]);
    const [disabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);

    const handleViability = () => {
        if(!viability.description || !viability.truck)
            return setSubmitted(true);

        setSubmitted(false);
        setLoading(true);
        var uri = viability.code ? '/viability/update' : '/viability/create';
        api().post(uri, { ...viability }).then(response => {
            if(response.status === 200 && response.data.result){
                if(!viability.code) {
                    setViability({...viability, code: response.data.data});
                }
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
            }
            setLoading(false)
        });
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || 0;
        let _viability = { ...viability };
        _viability[`${name}`] = val;

        setViability(_viability);
    }

    const onInputChangeFreight = (e) => {
        const val = (e.target && e.target.value) || 0;
        let _viability = { ...viability };
        _viability['shipping_price'] = val;
        _viability['commission'] = parseFloat((val * params['driverCommission'] / 100).toFixed(2));
        _viability['depreciation'] = parseFloat((val * params['truckWear'] / 100).toFixed(2));
        setViability(_viability);
    }

    const changeRoute = (e) => {
        const val = (e.target && e.target.value) || '';
        var _routes = val;

        var routesEnrichered = [];
        _routes.forEach(code => {
            var route = routes.find(route => route.code === code);
            if(route){
                routesEnrichered.push({
                    ...route
                });
            }
        });

        let _viability = { ...viability };
        _viability['routes'] = routesEnrichered;
        setViability(_viability);
        setRoutesSelected(routesEnrichered);

    }

    const listParams = () => {
        api().get('/param/list').then(response => {
            if(response.status === 200 && response.data.result){
                var _params = {...params};
                ['driverCommission', 'truckWear'].forEach(paramName => {
                    var found = response.data.data.find(param => param.name === paramName);
                    if(found) _params[paramName] = (found.valuefor);
                });
                setParams(_params);
            }
        });
    }

    const listViability = () => {
        if(code || false)
            api().get(`/viability/${code}`).then(response => {
                if(response.status === 200 && response.data.result){
                    setRoutesSelected(response.data.data.routes || []);
                    setViability(response.data.data);
                }
            });
    }

    const listRoutes = () => {
        api().get('/route/list').then(response => {
            if(response.status === 200 && response.data.result){
                setRoutes(response.data.data);
            }
        });
    }

    const listTrucks = () => {
        api().get('/truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                setTrucks(response.data.data.map(truck => {
                    truck['descriptionLong'] =
                        `${truck['plate'].toUpperCase()} - ${formatCurrency(truck.average_consumption)} (${truck.axle})`;
                    return truck;
                }));
            }
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Rotas</h5>
        </div>
    );

    useEffect(() => {
        listRoutes();
        listTrucks();
        listParams();
        listViability();
    }, []);

    useEffect(() => {
        var amountToll = 0, amountFuel = 0, distance = 0, truck = null, total = 0, multiplicator = viability.isempty ? 2 : 1;
        if(viability.truck)
            truck = trucks.find(truck => truck.code === viability.truck);

        routesSelected.forEach(value => {
            amountToll += value.total_tolls;
            distance += value.distance;
        });

        if(truck) {
            amountToll *= multiplicator;
            if( viability.fuelPrice)
                amountFuel = multiplicator * (distance / truck.average_consumption) *  viability.fuelPrice;
        }

        total = amountToll + amountFuel + viability.depreciation + viability.commission;

        setTollValue(amountToll);
        setTotalValue(total);
        setFuelValue(amountFuel);
        setProfitValue(viability.shipping_price - total);

    }, [viability]);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <Link to={'/viability'}><span style={{
                    display: 'block',
                    margin: '20px 0',
                    color: '#6b57d6',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                }}><i className="pi pi-arrow-left"></i> Voltar para lista de viabilidades</span></Link>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Lucro</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(profitValue, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-blue-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Custo</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(totalValue, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-blue-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Pedágios</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(tollValue, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-blue-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Combustível</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(fuelValue, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-blue-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <div className="p-fluid">
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="description">Descrição</label>
                                <InputText disabled={disabled} id="description" className={submitted && !viability.description ? "p-invalid p-error" : ""} value={viability.description} onChange={(e) => onInputChange(e, 'description')} required />
                                {submitted && !viability.description && <small className="p-invalid p-error">A descrição é obrigatória.</small>}
                            </div>
                        </div>

                        <div className="formgrid grid">
                            <div className="field lg:col-6 col-12">
                                <label htmlFor="shipping_price">Valor do Frete (R$)</label>
                                <InputDecimal disabled={disabled} focus id="shipping_price" mode="currency" value={viability.shipping_price} onChange={(e) => onInputChangeFreight(e)}  />
                            </div>
                            <div className="field col">
                                <label htmlFor="commission">Comissão do Motorista (R$)</label>
                                <InputDecimal id="commission" mode='currency' value={viability.commission}  />
                            </div>
                        </div>

                        <div className="formgrid grid">
                            <div className="field lg:col-6 col-12">
                                <label htmlFor="distance">Depreciação</label>
                                <InputDecimal id="distance" mode='currency' value={viability.depreciation} />
                            </div>
                            <div className="field col">
                                <label htmlFor="fuelPrice">Preço do Combustível (R$ / L)</label>
                                <InputDecimal disabled={disabled} id="fuelPrice" mode='currency' value={viability.fuelPrice} onChange={(e) => onInputChange(e, 'fuelPrice')}  />
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor='tolls'>Caminhão</label>
                            <Dropdown value={viability.truck} options={trucks} className={submitted && !viability.truck ? "p-invalid p-error" : ""} onChange={(e) => onInputChange(e, 'truck')} optionLabel="descriptionLong" optionValue='code' placeholder="Selecione um caminhão" />
                            {submitted && !viability.truck && <small className="p-invalid p-error">O caminhão é obrigatório.</small>}

                        </div>

                        <div className="field">
                            <label htmlFor='tolls'>Rotas</label>
                            <MultiSelect filter  value={viability.routes.map(route => route.code)} options={routes} onChange={(e) => changeRoute(e)} optionLabel="description" optionValue='code' placeholder="Selecione as rotas" />
                        </div>
                        <div className="field-checkbox">
                            <hr />
                            <Checkbox inputId="binary" checked={viability.isempty} onChange={e => {
                                var  _viability = { ...viability};
                                _viability['isempty'] = e.checked;
                                setViability(_viability);
                            }} />
                            <label htmlFor="binary">Considerar volta vazio</label>
                        </div>
                    </div>

                    <DataTable ref={dt} value={routesSelected} selection={selectedRoutes}
                        dataKey="id"  className="datatable-responsive"
                        paginatorTemplate=""
                        emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="description"  header="Descrição" headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column field="distance" body={rowData => (rowData.distance || 0) ? (formatCurrency(rowData.distance)) : '-'} header="Distância (Km)"></Column>
                        <Column field="total_tolls" body={rowData => (rowData.total_tolls || 0) ? (formatCurrency(rowData.total_tolls, true)) : '-'} header="Valor de Pedágios (R$)"></Column>
                    </DataTable>
                </div>
            </div>
            <div className="col-12">
                <Button
                    loading={loading}
                    label="Salvar"
                    icon="pi pi-save"
                    className="p-button-info"
                    style={{ float: "right" }}
                    onClick={handleViability}
                />
            </div>
        </div>
    );
}

export default Create;
